export enum Locale {
  English = 'en-US',
  // Spanish = 'es-US'
}
